/*
 * Analytics 2026-NL: consent-updates + cart- en UI-events naar de dataLayer.
 *
 * Drie taken:
 *  1. Shopify's privacy-banner vertalen naar Consent Mode v2-signalen voor GTM.
 *  2. add_to_cart / remove_from_cart afleiden uit cart-mutaties, ongeacht wélke UI
 *     ze veroorzaakt (PDP-formulier, quick-add, cart-drawer, configurator-app).
 *  3. UI-interacties op de PDP meten: swatch_click, color_popup_open,
 *     combo_deal_click, accordion_open, notify_me_submit en notify_me_details_submit.
 *  4. De kleurverkenner-promo in de homepage-hero meten: kleurverkenner_promo_click.
 *
 * Waarom een diff en geen klik-listener: de configurator en quick-add gebruiken elk
 * hun eigen knoppen. Door de cart zelf te vergelijken vangen we ze allemaal, en
 * blijven de events kloppen als er later UI bijkomt.
 */
(function () {
  'use strict';

  var ctx = window.TR_ANALYTICS || {};
  var currency = ctx.currency || 'EUR';

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  /* ─── 1. Consent ─────────────────────────────────────────────────────────── */

  function applyConsent(consent) {
    if (!consent) return;
    var analytics = consent.analytics === true ? 'granted' : 'denied';
    var marketing = consent.marketing === true ? 'granted' : 'denied';
    var preferences = consent.preferences === true ? 'granted' : 'denied';

    gtag('consent', 'update', {
      analytics_storage: analytics,
      ad_storage: marketing,
      ad_user_data: marketing,
      ad_personalization: marketing,
      functionality_storage: preferences,
      personalization_storage: preferences
    });
  }

  function readCurrentConsent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.currentVisitorConsent === 'function') {
        applyConsent(api.currentVisitorConsent());
      }
    } catch (e) {
      /* API nog niet geladen: de visitorConsentCollected-listener vangt het alsnog op */
    }
  }

  // Antwoord van de banner (of van een eerder bewaarde keuze).
  document.addEventListener('visitorConsentCollected', function (event) {
    applyConsent(event.detail);
  });

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) readCurrentConsent();
      }
    );
  } else {
    readCurrentConsent();
  }

  /* ─── 2. Cart-events ─────────────────────────────────────────────────────── */

  function indexCart(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      map[line.key] = {
        quantity: line.quantity,
        item: {
          item_id: line.sku || String(line.variant_id),
          item_name: line.product_title || line.title,
          item_brand: line.vendor,
          item_category: line.product_type,
          item_variant: line.variant_title || undefined,
          // Shopify geeft prijzen in centen; GA4 verwacht een bedrag in valuta-eenheden.
          price: (line.final_price != null ? line.final_price : line.price) / 100
        }
      };
    }
    return map;
  }

  var previous = indexCart(ctx.cart);

  function pushCartDelta(next) {
    var added = [];
    var removed = [];
    var key;

    for (key in next) {
      if (!Object.prototype.hasOwnProperty.call(next, key)) continue;
      var before = previous[key] ? previous[key].quantity : 0;
      var delta = next[key].quantity - before;
      if (delta > 0) {
        added.push(Object.assign({}, next[key].item, { quantity: delta }));
      } else if (delta < 0) {
        removed.push(Object.assign({}, next[key].item, { quantity: -delta }));
      }
    }

    // Regels die volledig verdwenen zijn, staan niet meer in `next`.
    for (key in previous) {
      if (!Object.prototype.hasOwnProperty.call(previous, key)) continue;
      if (!next[key]) {
        removed.push(
          Object.assign({}, previous[key].item, { quantity: previous[key].quantity })
        );
      }
    }

    previous = next;

    if (added.length) emit('add_to_cart', added);
    if (removed.length) emit('remove_from_cart', removed);
  }

  function emit(eventName, items) {
    var value = items.reduce(function (sum, item) {
      return sum + item.price * item.quantity;
    }, 0);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: currency,
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }

  var refreshPending = false;

  function refreshCart() {
    if (refreshPending) return;
    refreshPending = true;
    // Kleine vertraging: Shopify's cart is pas consistent nadat de mutatie is afgerond.
    setTimeout(function () {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) pushCartDelta(indexCart(cart));
        })
        .catch(function () {
          /* stil falen: analytics mag de winkel nooit breken */
        })
        .finally(function () {
          refreshPending = false;
        });
    }, 150);
  }

  var CART_MUTATIONS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isMutation = url && CART_MUTATIONS.test(url);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isMutation && response.ok) refreshCart();
        return response;
      });
    };
  }

  // Fallback voor formulieren die zonder fetch posten (harde navigatie naar /cart).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.action && CART_MUTATIONS.test(form.action)) refreshCart();
  });

  /* ─── 3. UI-interactie-events ────────────────────────────────────────────── */

  /*
   * De markup meldt zich aan met data-tr-*-attributen; hier staan gedelegeerde
   * listeners op document-niveau. Zo hoeft dit bestand niets te weten van secties of
   * renderorde, en blijft het werken als een snippet later ergens anders opduikt of
   * na het laden wordt ingevoegd (kleurwaarschuwing, combo-deal op de collectiepagina).
   *
   * Geen preventDefault en geen wachten: een dataLayer.push is synchroon, en GTM stuurt
   * de hit met sendBeacon: die overleeft de navigatie. Een klik op een link mag hier
   * dus nooit door opgehouden worden.
   */

  function pushSafe(payload) {
    try {
      window.dataLayer.push(payload);
    } catch (e) {
      /* stil falen: analytics mag de winkel nooit breken */
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var swatch = target.closest('[data-tr-swatch]');
    if (swatch) {
      pushSafe({
        event: 'swatch_click',
        swatch_color: swatch.getAttribute('data-tr-swatch') || '',
        // Attributen zijn tekst; GA4 krijgt liever een echte boolean.
        swatch_available: swatch.getAttribute('data-tr-available') === 'true'
      });
      return;
    }

    var popup = target.closest('[data-tr-color-popup]');
    if (popup) {
      pushSafe({
        event: 'color_popup_open',
        color: popup.getAttribute('data-tr-color') || '',
        sku: popup.getAttribute('data-tr-sku') || ''
      });
      return;
    }

    var combo = target.closest('[data-tr-combo-deal]');
    if (combo) {
      pushSafe({ event: 'combo_deal_click' });
      return;
    }

    // Kleurverkenner-promo in de homepage-hero (sections/home-2026-nl.liquid): het attribuut
    // draagt de variant (staalkaart op desktop, kleurenwiel op mobiel) zodat GA4 ze uit elkaar houdt.
    var kvPromo = target.closest('[data-tr-kv-promo]');
    if (kvPromo) {
      pushSafe({
        event: 'kleurverkenner_promo_click',
        promo_variant: kvPromo.getAttribute('data-tr-kv-promo') || ''
      });
    }
  });

  /*
   * notify_me_submit: de aanmelding "mail mij bij voorraad" op een uitverkochte PDP.
   * `submit` bubbelt wel, dus een gewone gedelegeerde listener op document volstaat.
   *
   * Sinds F0015 vangt assets/voorraadmelding-2026nl.js dezelfde submit af en roept daar
   * preventDefault() aan om de aanmelding als JSON naar de beheer-app te sturen. Dat raakt
   * deze meting niet: preventDefault() stopt alleen de standaardactie van de browser, niet
   * het bubbelen. Zolang niemand daar stopPropagation() aanroept, blijft dit event vuren,
   * of de aanmelding nu via de beheer-app of via de terugval naar /contact gaat.
   *
   * notify_me_details_submit (F0022): binnen diezelfde wrapper staat sinds stap 2 een
   * tweede formulier, met het gewenste aantal en de gewenste datum. Dat is geen nieuwe
   * aanmelding, dus het telt bewust NIET als notify_me_submit; anders zou elke ingevulde
   * stap 2 het aantal aanmeldingen verdubbelen. Alleen of de velden gevuld waren gaat mee,
   * nooit het e-mailadres, het aantal of de datum zelf.
   */
  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var notify = target.closest('[data-tr-notify]');
    if (!notify) return;

    var kleur = notify.getAttribute('data-tr-notify') || '';
    var stap2 = target.closest('[data-notify-stap2]');

    if (stap2) {
      var aantal = stap2.querySelector('[data-notify-aantal]');
      var datum = stap2.querySelector('[data-notify-datum]');
      pushSafe({
        event: 'notify_me_details_submit',
        color: kleur,
        has_qty: !!(aantal && String(aantal.value || '').trim()),
        has_date: !!(datum && String(datum.value || '').trim())
      });
      return;
    }

    pushSafe({
      event: 'notify_me_submit',
      color: kleur
    });
  });

  /*
   * accordion_open: `toggle` bubbelt niet, dus een gewone listener op document vangt
   * hem nooit. In de capture-fase daalt het event wél langs document af, en dat is de
   * enige manier om <details> gedelegeerd te meten.
   *
   * Eén event per blok per pageview: het gaat om "heeft iemand dit gelezen", niet om
   * hoe vaak hij open- en dichtklapt. De vlag staat op het element zelf, dus hij
   * verdwijnt vanzelf bij een nieuwe pagina.
   */
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || !details.hasAttribute || !details.hasAttribute('data-tr-accordion')) return;
      if (!details.open) return;
      if (details.dataset.trAccordionGemeten === '1') return;
      details.dataset.trAccordionGemeten = '1';

      pushSafe({
        event: 'accordion_open',
        accordion: details.getAttribute('data-tr-accordion') || ''
      });
    },
    true
  );
})();
